import React from 'react'
import { formatAmount, formatIntAmount } from '../../lib/formatAmountHandler'
import ListNumericInput from '../controls/ListNumericInput'
import ZestawienieRowStyle from '../../styles/ZestawienieRowStyle'
import Button from '@material-ui/core/Button'
import ListInput from '../../components/controls/ListInput'
import ListItemMenu from '../controls/ListItemMenu'

const ZestawienieRow = (props) => {
  return (
    <ZestawienieRowStyle>
      <div
        className={
          !props.readOnly || props.czyWylaczoneFormuly
            ? 'row edytowalny'
            : 'row'
        }
      >
        {props.czyPozycjaUzytkownika ? (
          <div className={`edycjanazwy wciecie${props.poziom}`}>
            <ListInput
              placeholder="Nazwa pozycji"
              name="Nazwa"
              value={props.nazwa || ''}
              hasError={(name, value) => {}}
              onValueChange={(e) =>
                props.onSetSectionDataArray(e, props.index, 'Nazwa')
              }
            />
          </div>
        ) : (
          <div
            className={`high-emphasis-body-1 name wciecie${props.poziom}`}
            title={props.opis}
          >
            {props.opis}
          </div>
        )}

        {props.readOnly && !props.czyWylaczoneFormuly ? (
          <>
            <span
              data-cy="kwotaA"
              className={`high-emphasis-body-1 value ${
                props.ukryjKwoty && 'hidden'
              }`}
            >
              {props.czyKwotyWTysiacach
                ? formatIntAmount(props.kwotaA)
                : formatAmount(props.kwotaA, 2)}
            </span>
            <span
              className={`high-emphasis-body-1 value ${
                props.ukryjKwoty && 'hidden'
              }`}
            >
              {props.czyKwotyWTysiacach
                ? formatIntAmount(props.kwotaB)
                : formatAmount(props.kwotaB, 2)}
            </span>

            <span
              className={
                props.isThirdColumn
                  ? `high-emphasis-body-1 value ${props.ukryjKwoty && 'hidden'}`
                  : 'hidden'
              }
            >
              {props.czyKwotyWTysiacach
                ? formatIntAmount(props.kwotaB1)
                : formatAmount(props.kwotaB1, 2)}
            </span>
          </>
        ) : (
          <>
            <div className="value">
              <ListNumericInput
                placeholder="Rok bieżący"
                value={props.kwotaA}
                onValueChange={(e) =>
                  props.onSetSectionDataArray(e, props.index, 'KwotaA')
                }
                czyKwotyWTysiacach={props.czyKwotyWTysiacach}
              />
            </div>
            <div className="value">
              <ListNumericInput
                placeholder="Rok poprzedni"
                value={props.kwotaB}
                onValueChange={(e) =>
                  props.onSetSectionDataArray(e, props.index, 'KwotaB')
                }
                czyKwotyWTysiacach={props.czyKwotyWTysiacach}
              />
            </div>

            <div className={props.isThirdColumn ? 'value' : 'hidden'}>
              <ListNumericInput
                placeholder="Przekształcone dane za poprzedni rok"
                value={props.kwotaB1}
                onValueChange={(e) =>
                  props.onSetSectionDataArray(e, props.index, 'KwotaB1')
                }
                czyKwotyWTysiacach={props.czyKwotyWTysiacach}
              />
            </div>
          </>
        )}

        {props.czyPozycjaUzytkownika && props.usunPozycjeUszczegolawiajaca && (
          <div className="menupozycji">
            <ListItemMenu
              options={[
                {
                  title: 'USUŃ',
                  action: () => props.usunPozycjeUszczegolawiajaca(props.index),
                },
              ]}
            />
          </div>
        )}
      </div>

      {props.uszczegolowienie && (
        <div className="wstawpozycje_hoverplace">
          <div className="wstawpozycje_linia">
            <Button
              tabIndex={-1}
              className="wstawpozycje_button"
              variant="contained"
              color="primary"
              onClick={() =>
                props.dodajPozycjeUszczegolawiajaca(
                  props.index,
                  props.uszczegolowienie.Sciezka,
                  props.uszczegolowienie.Poziom,
                )
              }
            >
              WSTAW TUTAJ POZYCJĘ USZCZEGÓŁAWIAJĄCĄ
            </Button>
          </div>
        </div>
      )}
    </ZestawienieRowStyle>
  )
}

export default ZestawienieRow
